import React from 'react';
import { AnimatedSection } from './AnimatedSection';
import { useNavigate } from 'react-router-dom';

export const Services = (props) => {
  const navigate = useNavigate();

  const handleIconClick = (serviceName) => {
    const matchId = serviceName.toLowerCase().split(' ')[0]; // Example: "Team Building" → "team"
    navigate(`/how-it-works`);
  };

  return (
    <div id="services" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Our Services</h2>
          <p>
            Whether you're just starting with an idea or ready to take your
            product to the next level, we’re here to support you every step of
            the way. From shaping your concept to launching and growing it, we
            work with you, not for you.
          </p>
        </div>
        <div className="row">
          {props.data
            ? props.data.map((d, i) => {
                const gradient = `linear-gradient(to right, ${d.gradientStart}, ${d.gradientEnd})`;

                return (
                  <div key={`${d.name}-${i}`} className="col-md-4">
                    <AnimatedSection>
                      <div className="service-box">
                        <div
                          className="service-icon"
                          style={{
                            backgroundImage: gradient,
                            cursor: 'pointer',
                          }}
                          onClick={() => handleIconClick(d.name)}
                          title={`Learn more about ${d.name}`}
                        >
                          <i className={d.icon}></i>
                        </div>
                        <div className="service-desc">
                          <h3>{d.name}</h3>
                          <p>{d.text}</p>
                        </div>
                      </div>
                    </AnimatedSection>
                  </div>
                );
              })
            : 'loading'}
        </div>
      </div>
    </div>
  );
};
